module.exports = {"id":"224836","name":"Vanja Milinković-Savić","rating":"71","photo":"./data/images/photos/1/224836.png","club":{"name":"Torino","logo":"./data/images/clubs/Torino.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VanjaMilinkovic-Savic0.json
// module id = 4233
// module chunks = 0